<template>
  <div>
    <v-flex xs12 row>
      <span style="font-size: 14px;">
        <b class="taxi-list-header">Drivers:</b>
        {{ taxis.length }}
        <b class="taxi-list-header">Trips:</b>
        {{ bookings.length }}
      </span>
    </v-flex>
    <v-flex
      style="font-size: 14px;"
      pb-1
      v-if="taxisForZone(zone.id).length > 0"
      xs12
      v-for="zone in zones"
    >
      <v-layout row wrap>
        <span style="padding-right: 12px;">
          <b class="taxi-list-header">{{zone.name}}:</b>
          {{taxisForZone(zone.id).length}}
        </span>
        <div
          v-for="item in taxisForZone(zone.id)"
          @click="setSelectedTaxi(item.id)"
          style="cursor: pointer;"
        >
          <v-menu right offset-x :close-on-content-click="false" v-model="menu[item.id.toString()]">
            <template v-slot:activator="{ on }">
              <div @click="showMenuForTaxi(item.id)" style="padding-top: 2px; margin-left: 4px;">
                <span v-bind:style="selectedTaxiStyle(item)" v-on="on" v-html="stateForTaxi(item)"></span>
              </div>
            </template>
            <DriverMenu @message="message" :taxi="item" @close="menu[item.id.toString()] = false" />
          </v-menu>
        </div>
      </v-layout>
    </v-flex>
    <v-flex style="font-size: 14px;" xs12>
      <v-layout row wrap>
        <span style="padding-right: 12px;">
          <b class="taxi-list-header">OOZ</b>
          {{taxisForZone(undefined).length}}
        </span>
        <div
          v-for="item in taxisForZone(undefined)"
          @click="setSelectedTaxi(item.id)"
          style="cursor: pointer"
        >
          <v-menu right offset-x :close-on-content-click="false" v-model="menu[item.id.toString()]">
            <template v-slot:activator="{ on }">
              <div @click="showMenuForTaxi(item.id)" style="padding-top: 2.0px; margin-left: 4px;">
                <span v-bind:style="selectedTaxiStyle(item)" v-on="on" v-html="stateForTaxi(item)"></span>
              </div>
            </template>
            <DriverMenu @message="message" :taxi="item" @close="menu[item.id.toString()] = false" />
          </v-menu>
        </div>
      </v-layout>
    </v-flex>
    <v-dialog v-model="messageDialog" width="600px">
      <MessageDriverDialog @sent="messageDialog = false" :taxi="taxi" />
    </v-dialog>
  </div>
</template>

<script>
import DriverMenu from "@/components/widget/menu/DriverMenu.vue";

import { Overwatch } from "@/components/util/Overwatch.js";
import MessageDriverDialog from "@/components/widget/menu/MessageDriverDialog.vue";

export default {
  name: "zone_list",
  components: {
    DriverMenu,
    MessageDriverDialog
  },
  model: {
    prop: "content",
    event: "input"
  },
  props: {
    taxis: Array,
    bookings: Array,
    rideTypes: Array,
    rideTypeEtas: Object,
    setSelectedTaxi: Function,
    selectedTaxi: Number,
    zones: Array
  },
  computed: {},
  data() {
    return {
      ABOUT_TO_CLEAR_TIME: 1,
      menu: [],
      messageDialog: false,
      taxi: null
    };
  },
  methods: {
    message: function(taxi) {
      console.log("Message dialog");
      this.messageDialog = true;
      this.taxi = taxi;
    },
    showMenuForTaxi: function(id) {
      console.log("Show menu for taxi " + id);
      this.menu[id.toString()] = true;
    },
    colorForRideTypeEta: function(rideType) {
      return {
        color:
          this.rideTypeEtas["ride_type_" + rideType.id] >
          rideType.availability_warning_threshold
            ? "lightcoral"
            : "limegreen"
      };
    },
    selectedTaxiStyle: function(taxi) {
      var style = {
        padding: "2px",
        borderRadius: "6px"
      };

      if (taxi.id == this.selectedTaxi) {
        style.color = "white";
        style.backgroundColor = "black";
      } else {
        var ow = new Overwatch(this.taxis, this.bookings);

        style.color = "black";
        style.backgroundColor = ow.colorForTaxi(taxi);
      }

      return style;
    },
    stateForTaxi: function(taxi) {
      var ow = new Overwatch(this.taxis, this.bookings);

      return ow.stateForTaxi(taxi);
    },
    taxisForZone: function(id, count) {
      if (this.taxis == null) {
        return [];
      }

      var ow = new Overwatch(
        this.taxis,
        this.bookings,
        this.$store.state.use_zone_based_dispatch
      );

      return ow.sortTaxisByState(
        this.taxis.filter(function(t) {
          return t.zone == id;
        })
      );
    },
    bookingsForZone: function(id) {
      if (this.bookings == null) {
        return [];
      }

      return this.bookings.filter(function(b) {
        return b.ride_type == id;
      });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
ul {
  list-style: none;
  padding-left: 0px;
}

.taxi-list-header {
  color: green;
  font-weight: 800;
}

.small-text {
  font-size: 13px;
}
</style>
